import { graphql, useFragment } from "react-relay";

import type {
  useClaudeMarketplace_query$data,
  useClaudeMarketplace_query$key,
} from "./__generated__/useClaudeMarketplace_query.graphql";

/** The marketplace as the store holds it, for the components that show it. */
export type ClaudeMarketplace = NonNullable<
  NonNullable<useClaudeMarketplace_query$data["UrlConfig"]>["claudeMarketplace"]
>;

/**
 * The Claude Code plugin marketplace this console serves, written into the
 * store at bootstrap from `/config/agent/claude.json`. Null on a platform
 * without one.
 */
export function useClaudeMarketplace(
  queryRef: useClaudeMarketplace_query$key,
): ClaudeMarketplace | null {
  const data = useFragment(
    graphql`
      fragment useClaudeMarketplace_query on Query {
        UrlConfig {
          claudeMarketplace {
            mcpServer
            name
            plugin
            url
          }
        }
      }
    `,
    queryRef,
  );

  const marketplace = data.UrlConfig?.claudeMarketplace;
  if (!marketplace) {
    return null;
  }
  const { mcpServer, name, plugin, url } = marketplace;
  return { mcpServer, name, plugin, url };
}
